import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import ReactTooltip from 'react-tooltip';

import tenantIdImage from '../../../assets/images/tenant_id.jpg';
import LocationIdImage from '../../../assets/images/location_id.jpg';
import '../index.scss';

const validateStaffLogin = (data,tenantId) => {
  const errors = {};

  if (!data.username) {
    errors.username = {
      message: 'Please enter a username',
    };
  }

  if (!data.password) {
    errors.password = {
      message: 'Please enter a password',
    };
  }

  if (!tenantId){
    errors.tenantId = {
      message: 'Please enter tenant Id',
    };
  }

  return errors;
};

export default class BookerAccountInfo extends React.Component {
  constructor(props) {
    super(props);

    // const { business } = this.props;

    this.state = {
      tenantId: '',
      username: '',
      password: '',
      errors: {},
      mandatoryFieldError: false,
    };

    this.onInputChange = this.onInputChange.bind(this);
    this.onNextButtonClick = this.onNextButtonClick.bind(this);
    this.validate = this.validate.bind(this);
  }

  onInputChange(event) {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }
  handleChange(event) {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }
  componentDidMount(){
    const { softwares } = this.props;
    const { meevoData, form , LOGIN , PASSWORD} = softwares;
    console.log('LOGIN 1',form , LOGIN , PASSWORD, this.state);
    this.setState({
      ...((meevoData.tenant_id || form.tenant_id) && {tenantId: form.tenant_id?form.tenant_id:meevoData.tenant_id}),
      ...((meevoData.username || LOGIN) && {username: meevoData.username?meevoData.username:LOGIN}),
      ...((meevoData.password || PASSWORD) && {password: meevoData.password?meevoData.password:PASSWORD}),
    });
  }
  componentWillUnmount(){
    console.log('Unmount state reset 2');
  }

  onNextButtonClick() {
    const { tenantId } = this.state;
      const data = {
        tenant_id: tenantId,
        client: 'MEEVO',
      };
      this.props.storeMeevoData(data);
      const validationResult = this.validate(data);
      if (validationResult) {
        this.props.postZenotiAccountInfo(data);
      }

      if(!this.state.username.trim() && !this.state.password.trim()){
      const skipdata = {
        skip:true
      };
      this.props.postStaffLogin(skipdata);
      console.log('Skip');
    }else{
      const data = {
        username: this.state.username,
        password: this.state.password,
      };
      const validationErrors = validateStaffLogin(data,tenantId);
      if (Object.keys(validationErrors).length) {
        this.setState({
          errors: validationErrors,
          mandatoryFieldError: true,
        });
      } else {
        this.setState(
          {
            errors: {},
            mandatoryFieldError: false,
          },
          () => {
            this.props.postStaffLogin(data);
            this.props.storeMeevoData({
              ...data,
              tenant_id: tenantId,
              client: 'MEEVO',
            });
          },
        );
        }
    }
  }

  validate(data) {
    if (!data.tenant_id) {
      this.setState({
        mandatoryFieldError: true,
      });

      return false;
    }
    this.setState({
      mandatoryFieldError: false,
    });

    return true;
  }

  render() {
    const { tenantId, mandatoryFieldError,credType, errors,username, password } = this.state;
    const { softwares , dashboard} = this.props;
    const { info, form } = softwares;
    const isSwConnected = dashboard.tasksStatus.bookingSW_connect === 'completed';
    console.log('STATE',isSwConnected, info, form);
    console.log("SOFTWARES", softwares);
    return (
      <div className="authorize-access">
        <form className="authorize-access__form">
          {mandatoryFieldError ? (
            <p className="authorize-access__error">
              <i className="fa fa-exclamation-circle" aria-hidden="true" />
              Fields marked in red are mandatory!
            </p>
          ) : null}
          {softwares.isBookerAccountInfoSaveFail ? (
            <p className="authorize-access__error">
              <i className="fa fa-exclamation-circle" aria-hidden="true" />
              Unable to save account information
            </p>
          ) : null}

          {softwares.isAuthError ? (
            <p className="authorize-access__error">
              <i className="fa fa-exclamation-circle" aria-hidden="true" />
              Invalid Credentials Submitted
            </p>
          ) : null}
          
          <div className="authorize-access__form__row form-group">
            <p className="form-group__heading">Enter your Tenant Id &#42;</p>
            <input
              type="text"
              name="tenantId"
              className={classnames({ 'has-error': (mandatoryFieldError ||  errors.tenantId)})}
              value={tenantId}
              onChange={this.onInputChange}
              disabled={isSwConnected}
              autoComplete="false"
            />
          </div>
          <p className="authorize-access_hint">
          <a
            className="authorize-access__help-text"
            data-tip
            data-for="tenantIdHelp"
          >
                  Hint: Your Meevo Tenant Id is the same as the leading
                  part of the URL for your Meevo online account
          </a>
          </p>
          <ReactTooltip
            id="tenantIdHelp"
            className="authorize-access__help-tooltip"
          >
            <img src={tenantIdImage} alt="tenant ID" width="600" />
          </ReactTooltip>
          
          <section className="authorize-access__sw-details">
            <p className="authorize-access__heading">
              Please create a staff login on your Meevo software for TrueLark to use and enter
              those here (optional)
            </p>
            <div className="authorize-access__form__row form-group">
              <p className="form-group__heading">Username</p>
              <input
                type="text"
                name="username"
                className={classnames({
                  'has-error': errors.username,
                })}
                value={username}
                onChange={this.onInputChange}
                autoComplete="false"
                placeholder="Username"
                //disabled={isSwConnected}
              />
            </div>

            <div className="authorize-access__form__row form-group">
              <p className="form-group__heading">Password</p>
              <input
                type="text"
                name="password"
                className={classnames({
                  'has-error': errors.password,
                })}
                value={password}
                onChange={this.onInputChange}
                autoComplete="false"
                placeholder="password"
                //disabled={isSwConnected}
              />
            </div>
          </section>
        </form>
        <div className="authorize-access__actions">
          <button className="btn btn--secondary btn--lg" type="button" onClick={this.props.onBackClick}>
            Previous
          </button>
          <button
            className="btn btn--primary btn--lg"
            onClick={this.onNextButtonClick}
            disabled={softwares.isSavingBookerAccountInfo}
          >
            {!softwares.isSavingBookerAccountInfo ? 'Next' : 'Saving...'}
          </button>
        </div>
      </div>
    );
  }
}

BookerAccountInfo.defaultProps = {
  postZenotiAccountInfo: () => {},
  onBackClick: () => {},
};

BookerAccountInfo.propTypes = {
  postZenotiAccountInfo: PropTypes.func,
  onBackClick: PropTypes.func,
  softwares: PropTypes.shape().isRequired,
};
